import { useCallback } from 'react';

import { eventNames, CoreEvent } from '@carvana/core-events';
import { makeEventName, recordMoMetricsEvent } from '../utilities/moMetrics';

const useAccountModal = (app: string, component: string) => {
  const recordSignInEvent = useCallback(
    (eventName: string, error?: Error) => {
      eventName = makeEventName(eventName);
      const eventDetails = { eventName, eventTime: new Date() };
      recordMoMetricsEvent(eventDetails, { app, component, error });
    },
    [app, component]
  );

  const signIn = (handleSuccess?: Function) => {
    CoreEvent.emit(eventNames.accountModal.open, {
      OnAuthenticatedSuccess: () => {
        recordSignInEvent('SignIn Success');
        if (typeof handleSuccess === 'function') {
          handleSuccess();
        }

        CoreEvent.emit(eventNames.accountModal.close);
      },
      step: 'email-form',
      CallerIdentifier: 'TradesPage'
    });
  };

  return { signIn };
};

export default useAccountModal;
